import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { ContentAlignment } from 'shared-global-ec-uikit/components/dist/react/esm/components/content-alignment'
import { CollectionList } from 'shared-global-ec-uikit/components/dist/react/esm/components/collection-list'
import { spacingClassNames } from 'utils'

type Props = {
  numberOfResults: number
}

const createSingleResultSkeleton = (index: number) => (
  <SkeletonTheme baseColor="#DADADA" highlightColor="#A1A1A1" key={index}>
    <ContentAlignment element="div" direction="column">
      <span className={spacingClassNames({ sm: 2, md: 2, lg: 2, xl: 2 })}>
        <Skeleton width={160} height={12} />
      </span>
      <span className={spacingClassNames({ sm: 2, md: 2, lg: 2, xl: 2 })}>
        <Skeleton width={324} height={12} />
      </span>
      <span className={spacingClassNames({ sm: 2, md: 2, lg: 2, xl: 2 })}>
        <Skeleton width={324} height={12} />
      </span>
      <Skeleton width={228} height={12} />
    </ContentAlignment>
  </SkeletonTheme>
)

const generateSkeletons = (numberOfResults: number) => {
  const output = []
  for (let i = 0; i < numberOfResults; i++) {
    output.push(createSingleResultSkeleton(i))
  }
  return output
}

const LoadingSkeleton: React.FC<Props> = ({ numberOfResults }: Props) => (
  <div style={{ position: 'relative' }}>
    <CollectionList keylines="between-items" spacing>
      {generateSkeletons(numberOfResults)}
    </CollectionList>
    <div
      style={{
        position: 'absolute',
        top: '0',
        left: '0',
        //height: `${183 * numberOfResults}px`,
        height: '100%',
        width: '100%',
        background:
          'linear-gradient(rgba(355, 355, 355, 0) 0%, rgba(355, 355, 355, 0.5) 30%, rgba(355, 355, 355, 1) 100%)',
      }}
    ></div>
  </div>
)

export default LoadingSkeleton
